// AddressCard.jsx
import React from "react";

function AddressCard({ address, onEdit, onRemove }) {
    return (
        <div className="border border-neutral-300 bg-white p-6">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">

                {/* Left: Name & Phone */}
                <div className="flex flex-col w-full md:w-1/4">
                    <p className="text-sm font-medium uppercase text-neutral-800">
                        {address?.name}
                    </p>
                    <p className="text-sm text-neutral-700">
                        {address?.mobile}
                    </p>
                </div>

                {/* Center: Address */}
                <div className="text-sm text-neutral-700 w-full md:w-2/4 break-words">
                    {address?.addressLine1}<br />
                    {address?.postOffice}, {address?.city}<br />
                    {address?.state}, {address?.country} - {address?.zipcode}
                </div>

                {/* Right: Buttons */}
                <div className="flex gap-3 w-full md:w-1/4 justify-start md:justify-end">
                    <button
                        onClick={onEdit}
                        className="h-9 bg-neutral-200 px-6 text-xs uppercase tracking-wide text-neutral-800 hover:bg-neutral-300"
                    >
                        Edit
                    </button>
                    <button
                        onClick={onRemove}
                        className="h-9 bg-neutral-200 px-6 text-xs uppercase tracking-wide text-neutral-800 hover:bg-neutral-300"
                    >
                        Delete
                    </button>
                </div>

            </div>
        </div>
    );
}

export default AddressCard;
